const colorArr = [
    "#ECF8F7",
    "#F5FFF9",
    "#EAFEF3",
    "#F8FDFF",
    "#FFFFE5",

    "#FFFFF3",
    "#F6ECF4",
    "#FFEBE8",
    "#F6EAF3",
    "#FFF8EA",

    "#F3F5FE",
    "#ECF5FA",
    "#FFE0E5",
    "#E5FFEC",
    "#FAFAFF",

    "#F0F7FF",
    "#DBFFC0",
    "#CDFDD4",
    "#FFFCFE",
    "#F8FEEF",
];

export default colorArr;